import { isObject } from "./primitives";

export function toFormData<ObjT extends Record<string, unknown>>(obj: ObjT): FormData {
	const formData = new FormData();
	for (const key of Object.keys(obj)) {
		if (isObject(obj[key])) {
			formData.append(key, JSON.stringify(obj[key]))
		} else if (obj[key]?.toString !== undefined) {
			formData.append(key, obj[key].toString())
		} else {
			formData.append(key, String(obj[key]))
		}
	}
	return formData;
}